
class FrontendConfig {

  protected settings: Map<string, string | undefined>;

  /**
   *
   */
  constructor() {
    // get values from global frontend-config
    const config = (<any>window).CONF;

    // check if config is defined
    if (!config) {
      throw new Error('global frontend-config "window.CONF" is not defined!');
    }

    // initialize settings
    this.settings = new Map<string, string>();
    Object.entries(config).forEach(([key, value]) => {
      this.settings.set(key, value?.toString());
    });
  }

  /**
   * Return the option with the given key or undefined if it does not exist.
   */
  public get(key: string): string | undefined {
    if (!this.settings) return undefined;
    return this.settings.get(key);
  }

}

// create singleton instance
const config = new FrontendConfig();
export default config;
